import { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { Navigate, Outlet, useNavigation } from 'react-router-dom';

import { useOauthRedirect } from '@/components/AuthModal/hooks';
import ModalContactPrivate from '@/components/ModalContactPrivate';
import ModalErrorUploadPdf from '@/components/ModalErrorUploadPdf';
import ModalUpgradePlan from '@/components/ModalUpgradePlan';
import { useMediaQuery, useShallowEqualSelector } from '@/hooks';
import { fetchUser } from '@/store/profile/thunks';

import CheckoutLayout from '../CheckoutLayout';
import NoIndexMeta from '../NoIndexMeta';
import Scroller from '../Scroller';
import { useIsLoadingCheckout, useLayout } from '../hooks';
import Header from './Header';
import Sidebar from './Sidebar';
import { Loader, Wrapper } from './components';

function PrivateLayout() {
	const mdDown = useMediaQuery('mdDown');
	const dispatch = useDispatch();
	const navigation = useNavigation();
	const isLoadingCheckout = useIsLoadingCheckout();

	const { loggedIn, fetchUserCompleted, userReady } = useShallowEqualSelector(
		({ profile }) => ({
			loggedIn: profile.loggedIn,
			fetchUserCompleted: profile.fetchUser.completed,
			userReady: profile.userReady
		})
	);
	useLayout();
	useOauthRedirect();

	useEffect(() => {
		if (!fetchUserCompleted || !loggedIn) {
			dispatch(fetchUser());
		}
	}, []);

	if (fetchUserCompleted && !loggedIn) {
		return <Navigate to="/" />;
	}

	if (isLoadingCheckout) {
		return <CheckoutLayout />;
	}

	if (!fetchUserCompleted && (!loggedIn || !userReady)) {
		return (
			<>
				{mdDown && <Header />}
				<NoIndexMeta />
				<div className="flex">
					{!mdDown && <Sidebar />}
					<Wrapper>
						<Loader />
					</Wrapper>
				</div>
			</>
		);
	}

	return (
		<>
			<Scroller />
			<NoIndexMeta />
			{mdDown && <Header />}
			<div className="flex">
				{!mdDown && <Sidebar />}
				<Wrapper>
					{navigation.state === 'loading' ? <Loader /> : <Outlet />}
				</Wrapper>
			</div>
			<ModalContactPrivate />
			<ModalErrorUploadPdf />
			<ModalUpgradePlan />
		</>
	);
}

export default PrivateLayout;
